import { Component, HostListener, Input, ElementRef, ViewChild} from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { HeaderComponent } from 'app/header/header.component';
import { UserAccount } from 'app/services/userAccount.service';
import { ContribService } from '../contrib.service';
import { CurrentUser } from 'app/services/currentUser.service';
import { AppHeaderComponent } from 'app/header/appHeader/appHeader.component';
import { SafeUrl } from '@angular/platform-browser';
import { forkJoin } from 'rxjs';

@Component({
  selector: 'contrib-welcome',
  templateUrl: './welcome.component.html',
  styleUrls: ['./welcome.component.scss', '../contrib.component.scss'],
  providers: [HeaderComponent, AppHeaderComponent],
})
export class WelcomeComponent {
  @Input() isMobile;
  @Input() owner;
  @Input() projectInfo;
  @Input() isguest;
  @ViewChild('submitButton', {static: false}) submitButton: ElementRef;
  guest = this.userAccount.data.first_name;
  data;
  modalOpen: boolean;
  storyCover: SafeUrl;
  canEdit: boolean;
  change: boolean;
  required: boolean;
  noPhotoModal: boolean;
  signUp: boolean;
  isLoading: boolean;
  errors;
  constructor(private router: Router,
     public userAccount: UserAccount,
     private activatedRoute: ActivatedRoute,
     private currentUser: CurrentUser) {
  }


  @HostListener('document:keydown.enter', ['$event']) onKeydownHandler(event: KeyboardEvent) {
    event.preventDefault();
    this.submitButton.nativeElement.click();
  }

  submit(firstName: string) {
    if (firstName !== '' || this.userAccount.data.first_name !== '') {
      this.required = false;
      if (this.isguest) {
        if (this.userAccount.data.first_name === firstName) {
          this.currentUser.setFirstName(firstName);
          this.userAccount.set(this.currentUser.get());
          this.currentUser.userName(firstName).subscribe(x => {
            this.redirect();
          });
        } else {
          this.currentUser.createUser().subscribe(d => {
            this.currentUser.set(d);
            this.isguest = this.currentUser.get() ? this.currentUser.get().guest : false;
            this.currentUser.setFirstName(firstName);
            this.userAccount.set(this.currentUser.get());
            forkJoin(
              this.currentUser.userName(firstName),
              this.currentUser.acceptShare(this.activatedRoute.snapshot.queryParamMap.get('token'))
            ).subscribe(x => {
              this.redirect();
            });
          });
        }
      }
      if (this.userAccount.data.first_name) {
        this.redirect();
      }
    } else {
      this.required = true;
    }
  }

  redirect() {
    this.router.navigate(['projects/' + this.projectInfo.id + '/contribute/wizard'],
    {queryParams: {token: this.activatedRoute.snapshot.queryParamMap.get('token')}});
  }

  setIsLoading(ev) {
    this.isLoading = ev;
  }
  setError(ev) {
    this.errors = ev;
  }

  logIn() {
    this.router.navigate(['account/login'],
    {queryParams: {contrib: this.router.url }});
  }

  haveAccount() {
    if ((this.currentUser.get() ? this.currentUser.get().guest : false) && this.change) {
      this.isguest = false;
      return false;
    } else {
      return true;
    }
  }

  wantToLog() {
    this.router.navigate(['account/sign_up'],
    {queryParams: {contrib: this.router.url, signUp: true }});
  }

  noPhoto() {
    if (this.noPhotoModal) {
      this.noPhotoModal = false;
    } else {
      this.noPhotoModal = true;
    }
  }
}
